import React from "react";
import Star from "./Star";

export interface StarsProps {
  rating: number;
  size?: string;
}

const Stars = ({ rating, size }: StarsProps) => {
  return (
    <div className="flex">
      {Array.from(Array(5)).map((_, i) => {
        const isHalf = i + 0.5;
        return (
          <div key={i} className="mr-[0.25rem]">
            <Star size={size} half={rating >= isHalf} full={rating >= i + 1} />
          </div>
        );
      })}
    </div>
  );
};

export default Stars;
